import u from '@/utils'
import Promise from 'bluebird'
import axios from 'axios'

const state = {
  hivesLoading: false,
  hives: [],
  hiveBots: {},
  hiveNativeBots: [],
  hiveBotTemplates: [],
  hiveConnectionStructures: []
}

const getters = {
  getHives(state) {
    return state.hives
  },

  getHiveConnectionStructures() {
    return state.hiveConnectionStructures
  }
}

const mutations = {
  sethivesLoading(state, isLoading) {
    state.hivesLoading = isLoading
  },

  setHives(state, hives) {
    state.hives = hives
  },

  updateHive(state, hive) {
    let index = state.hives.findIndex(item => item.hexId === hive.hexId)
    state.hives.splice(index, 1, hive)
  },

  setHiveBots(state, payload) {
    state.hiveBots = {
      ...state.hiveBots,
      [payload.hive.hexId]: payload.bots
    }
  },

  setHiveNativeBots(state, hiveNativeBots) {
    state.hiveNativeBots = hiveNativeBots
  },

  setHiveBotTemplates(state, hiveBotTemplates) {
    state.hiveBotTemplates = hiveBotTemplates
  },

  setHiveConnectionStructures(state, hiveConnectionStructures) {
    state.hiveConnectionStructures = hiveConnectionStructures
  }
}

const actions = {
  async fetchHiveConnectionStructures({ commit }) {
    let response = await axios.get('/api/v1/hives/hiveConnectionStructure')
    let hiveConnectionStructure = [
      ...response.data._embedded.hiveStructureModels
    ]
    hiveConnectionStructure = hiveConnectionStructure.map(item => {
      item.options = item.options.sort((prev, curr) => {
        return prev.order > curr.order ? 1 : -1
      })
      return item
    })
    commit('setHiveConnectionStructures', hiveConnectionStructure)
  },

  async fetchHives({ commit }) {
    commit('sethivesLoading', true)
    let response = await axios.get('/api/v1/hives')
    let hives = [...response.data._embedded.hives]
    hives = hives.map(hive => u.processResp(hive))
    commit('setHives', hives)
    commit('sethivesLoading', false)
    return hives
  },

  async checkHiveBeat(context, hiveHexId) {
    let response = await axios.get(`/api/v1/hives/${hiveHexId}/heartbeat`)
    return response.data
  },

  async updateHive({ commit }, { body, hexId }) {
    let response = await axios.patch(`/api/v1/hives/${hexId}`, body)
    response.data = u.processResp(response.data)
    commit('updateHive', response.data)
    return response.data
  },

  async updateHiveCredential({ commit }, { body, hexId, identityType }) {
    let response = await axios.patch(
      `/api/v1/hives/${hexId}/credentials/${identityType}`,
      body
    )
    response.data = u.processResp(response.data)
    commit('updateHive', response.data)
    return response.data
  },

  async fetchHiveBots({ commit }, hive) {
    let response = await axios.get(`/api/v1/hives/${hive.hexId}/bots`)
    if (response.data._embedded) {
      let bots = [...response.data._embedded.bots]
      bots = bots.map(bot => u.processResp(bot))
      commit('setHiveBots', { hive, bots })
      return bots
    }
  },

  async fetchHiveNativeBots({ commit }, hiveHexId) {
    commit('setHiveNativeBots', [])
    let response = await axios.get(`/api/v1/hives/${hiveHexId}/hiveBots`)
    if (response.data._embedded) {
      let hiveBots = [...response.data._embedded.hiveBotModels]
      hiveBots = hiveBots.map(hiveBot => u.processResp(hiveBot))
      commit('setHiveNativeBots', hiveBots)
      return hiveBots
    }
  },

  async fetchHiveBotTemplates({ commit }, hiveHexId) {
    commit('setHiveBotTemplates', [])
    let response = await axios.get(
      '/api/v1/hives/' + hiveHexId + '/botTemplates'
    )
    if (response.data._embedded) {
      let botTemplates = [...response.data._embedded.botTemplates]
      botTemplates = botTemplates.map(botTemplate => u.processResp(botTemplate))
      commit('setHiveBotTemplates', botTemplates)
      return botTemplates
    }
  },

  async saveHive(context, hiveBody) {
    let response = await axios.post('/api/v1/hives', hiveBody)
    return response.data
  },

  async deleteHive(context, hiveHexId) {
    await axios.delete(`/api/v1/hives/${hiveHexId}`)
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}
